import { Fragment } from 'react';
import { cn } from '@/shared/lib/cn';

export interface KbdProps {
  /** Keys of a shortcut, e.g. `["Ctrl", "S"]` → Ctrl + S (561:17417). */
  keys?: string[];
  /** A single key cap (alternative to `keys`). */
  children?: React.ReactNode;
  className?: string;
}

/** Key cap: h23, padding 2/8, r6, White/10 + 1px White/10 inside, Inter 500 12/17 (spec §4.19, 561:17417). */
export function KbdKey({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <kbd
      className={cn(
        'inline-flex h-23 min-w-23 items-center justify-center rounded-6 border border-line bg-field px-8 font-sans text-xs leading-17 font-medium tracking-normal text-fg',
        className,
      )}
    >
      {children}
    </kbd>
  );
}

/** Keyboard shortcut — key caps joined by "+" (400 11/15 White/60, gap 4). */
export function Kbd({ keys, children, className }: KbdProps) {
  if (!keys) return <KbdKey className={className}>{children}</KbdKey>;
  return (
    <kbd className={cn('inline-flex items-center gap-4 font-sans', className)}>
      {keys.map((key, i) => (
        <Fragment key={`${key}-${i}`}>
          {i > 0 && (
            <span aria-hidden className="text-11 text-fg-secondary">
              +
            </span>
          )}
          <KbdKey>{key}</KbdKey>
        </Fragment>
      ))}
    </kbd>
  );
}
